import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'navy' | 'navy-light' | 'navy-dark';
  id?: string;
}
export const Section: React.FC<SectionProps> = ({
  children,
  className = '',
  variant = 'navy',
  id
}) => {
  const bgColors = {
    navy: 'bg-navy',
    'navy-light': 'bg-navy-light',
    'navy-dark': 'bg-navy-dark'
  };
  return <section id={id} className={`py-20 md:py-32 px-4 sm:px-6 lg:px-8 ${bgColors[variant]} ${className}`} data-id="element-150">
      <div className="max-w-4xl mx-auto" data-id="element-151">{children}</div>
    </section>;
};